// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  line-height: 1.7rem;
}

.vrm {
  padding-right: 5px;
  padding-left: 5px;
  border-radius: 3px;
}

.min-flex {
  flex-basis: 220px;
}

.edit-advert-icon {
  color: var(--topbarIconColour);
}

.page-header {
  font-weight: 700 !important;
}

.watchlist-container {
  line-height: 46px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  box-sizing: content-box;
}
.watchlist-container .watchlist-state {
  border-radius: 50%;
  box-sizing: content-box;
}

.non-runner {
  background-color: var(--errorColour);
  color: #fff;
  text-align: center;
  font-size: 0.875rem;
  font-weight: bold;
  margin-bottom: 7px;
  padding: 5px 8px;
  border-radius: 5px;
}

.inline {
  min-width: 120px;
  font-size: 13px;
  font-weight: 400;
}

.infobar-cell {
  display: inline-block;
  width: 46px;
  height: 46px;
  vertical-align: middle;
  border-radius: 23px;
  background-color: #fff;
  box-shadow: 2px 2px 2px 0px rgba(50, 50, 50, 0.1);
}
.infobar-cell:hover {
  background-color: var(--linkColour) !important;
  color: #fff !important;
}

.grade-bg {
  background-color: #8FAE2D;
  border-radius: 3px;
  text-align: center;
  padding: 5px 10px;
}

.grade-title {
  content: "Grade";
  font-size: 12px;
  line-height: 13px;
  color: white;
  font-weight: 400;
}

.grade {
  font-size: 28px;
  color: white;
  font-weight: 500;
  line-height: 24px;
}

#sellers-comment-widget {
  font-size: 0.8rem;
  font-weight: 500;
  flex-grow: 1;
  min-height: 100px;
  white-space: pre-line;
  padding-bottom: 10px;
  overflow-y: auto;
  line-height: 1.5rem;
  max-height: 380px;
}

.proxy-bid-header {
  background-color: var(--primaryColour);
  color: #fff;
  border-radius: 6px 6px 0 0;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 2px 0;
}

.main-gallery { /* min-height: 500px; */
  width: 100%;
  aspect-ratio: var(--aspectRatio, 1.33);
}

.pair-label {
  font-size: 0.6rem;
  font-weight: 500;
  color: var(--textLabelColour) !important;
}

.sellers-comment {
  font-weight: 400;
}

.pair-value {
  font-size: 0.85rem;
  font-weight: 500;
}

.documents .widget {
  min-width: 100px;
  margin-bottom: 5px;
}

.rate-title {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 10px;
}

.modal-title {
  font-size: 16px;
  font-weight: 400;
}

.saletype-label {
  vertical-align: text-bottom;
  padding: 0px 10px;
  border-radius: 11px;
  font-size: 0.875rem;
  font-weight: 500;
  display: inline-block;
  letter-spacing: 0px;
  line-height: 22px;
}

.key-infos {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 10px;
}
.key-infos .key-info {
  background-color: var(--chipBackgroundColour);
  border: 1px solid #eee;
  color: var(--textColour);
  font-size: 13px;
  line-height: 13px;
  font-weight: 400;
  display: inline-block;
  white-space: nowrap;
  vertical-align: baseline;
  padding: 8px 14px;
  border-radius: 15px;
  align-items: center;
}
.key-infos .key-vrm {
  background-color: var(--vrmBackgroundColourLight);
  border: 1px #eed99b;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/main/advert/advert-view/advert-view.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAGA;EACE,8BAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EAEE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;AADF;AAGE;EACE,kBAAA;EACA,uBAAA;AADJ;;AAKA;EACE,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAMA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAMA;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iDAAA;AAJF;AAME;EACE,8CAAA;EACA,sBAAA;AAJJ;;AAQA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AALF;;AAQA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AALF;;AAQA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AALF;;AAQA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AALF;;AAQA;EAEE,sCAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AANF;;AASA,gBAAA,uBAAA;EACE,WAAA;EACA,sCAAA;AANF;;AAUA;EACE,iBAAA;EACA,gBAAA;EACA,wCAAA;AAPF;;AAUA;EACE,gBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,gBAAA;AAPF;;AAUA;EAEE,gBAAA;EACA,kBAAA;AARF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AATF;;AAYA;EAEE,aAAA;EACA,eAAA;EACA,cAAA;AAVF;AAYE;EACE,6CAAA;EACA,sBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,wBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAVJ;AAaE;EACE,iDAAA;EACA,mBAAA;EACA,gBAAA;AAXJ","sourcesContent":["h1 {\n  line-height: 1.7rem;\n}\n\n.vrm {\n  padding-right: 5px;\n  padding-left: 5px;\n  border-radius: 3px;\n}\n\n.min-flex {\n  flex-basis: 220px;\n\n}\n\n.edit-advert-icon {\n  color: var(--topbarIconColour);\n}\n\n.page-header {\n  font-weight: 700 !important;\n}\n\n.watchlist-container {\n\n  line-height: 46px;\n  text-align: center;\n  font-size: 20px;\n  cursor: pointer;\n  box-sizing: content-box;\n\n  .watchlist-state {\n    border-radius: 50%;\n    box-sizing: content-box;\n  }\n}\n\n.non-runner {\n  background-color: var(--errorColour);\n  color: #fff;\n  text-align: center;\n  font-size: 0.875rem;\n  font-weight: bold;\n  margin-bottom: 7px;\n  padding: 5px 8px;\n  border-radius: 5px;\n}\n\n\n.inline {\n  min-width: 120px;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.infobar-cell {\n\n  display: inline-block;\n  width: 46px;\n  height: 46px;\n  vertical-align: middle;\n  border-radius: 23px;\n  background-color: #fff;\n  box-shadow: 2px 2px 2px 0px rgb(50 50 50 / 10%);\n\n  &:hover {\n    background-color: var(--linkColour) !important;\n    color: #fff !important;\n  }\n}\n\n.grade-bg {\n  background-color: #8FAE2D;\n  border-radius: 3px;\n  text-align: center;\n  padding: 5px 10px;\n}\n\n.grade-title {\n  content: 'Grade';\n  font-size: 12px;\n  line-height: 13px;\n  color: white;\n  font-weight: 400;\n}\n\n.grade {\n  font-size: 28px;\n  color: white;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n#sellers-comment-widget {\n  font-size: 0.8rem;\n  font-weight: 500;\n  flex-grow: 1;\n  min-height: 100px;\n  white-space: pre-line;\n  padding-bottom: 10px;\n  overflow-y: auto;\n  line-height: 1.5rem;\n  max-height: 380px;\n}\n\n.proxy-bid-header {\n\n  background-color: var(--primaryColour);\n  color: #fff;\n  border-radius: 6px 6px 0 0;\n  font-size: 0.85rem;\n  font-weight: 500;\n  padding: 2px 0;\n}\n\n.main-gallery { /* min-height: 500px; */\n  width: 100%;\n  aspect-ratio: var(--aspectRatio, 1.33);\n}\n\n\n.pair-label {\n  font-size: 0.6rem;\n  font-weight: 500;\n  color: var(--textLabelColour) !important;\n}\n\n.sellers-comment {\n  font-weight: 400;\n}\n\n.pair-value {\n  font-size: 0.85rem;\n  font-weight: 500\n}\n\n.documents .widget {\n\n  min-width: 100px;\n  margin-bottom: 5px;\n\n}\n\n.rate-title {\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.modal-title {\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.saletype-label {\n  vertical-align: text-bottom;\n  padding: 0px 10px;\n  border-radius: 11px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  display: inline-block;\n  letter-spacing: 0px;\n  line-height: 22px;\n}\n\n.key-infos {\n\n  display: flex;\n  flex-wrap: wrap;\n  grid-gap: 10px;\n\n  .key-info {\n    background-color: var(--chipBackgroundColour);\n    border: 1px solid #eee;\n    color: var(--textColour);\n    font-size: 13px;\n    line-height: 13px;\n    font-weight: 400;\n    display: inline-block;\n    white-space: nowrap;\n    vertical-align: baseline;\n    padding: 8px 14px;\n    border-radius: 15px;\n    align-items: center;\n  }\n\n  .key-vrm {\n    background-color: var(--vrmBackgroundColourLight);\n    border: 1px #eed99b;\n    font-weight: 500;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
